import React, { useRef } from "react";

const VideoRoomEmpty = () => {
	// const userVideo = useRef();
	// const partnerVideo = useRef();

	return (
		<div className="video-page">
			<div className="video-container">
				<div className="user-video"></div>
				<div className="partner-video"></div>
				{/* <video muted className="user-video" autoPlay ref={userVideo} />
				<video className="partner-video" autoPlay ref={partnerVideo} /> */}
			</div>
		</div>
	);
};

export default VideoRoomEmpty;
